/**
 * Formats the name of a composition schema to a human-readable format.
 */
export const formatFCompositionSchemaName = (name: string) =>
  name
    .replace(/(arrangement|ensemble|composition)/i, '')
    .replace(/-/g, ' ')
    .trim()
    .replace(/^./, (str: string) => str.toUpperCase());
